var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTolls({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13673_3975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41753 3.33366C9.46965 2.30267 10.9106 1.66699 12.5 1.66699C15.7217 1.66699 18.3334 4.27866 18.3334 7.50033C18.3334 9.08977 17.6977 10.5307 16.6666 11.5829M13.3334 12.5003C13.3334 15.722 10.7217 18.3337 7.50002 18.3337C4.27836 18.3337 1.66669 15.722 1.66669 12.5003C1.66669 9.27866 4.27836 6.66699 7.50002 6.66699C10.7217 6.66699 13.3334 9.27866 13.3334 12.5003Z",
    stroke: "#165AE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13673_3975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTolls);
export default __webpack_public_path__ + "static/media/tolls.9dfe753086a20952eb1d9ae622a79586.svg";
export { ForwardRef as ReactComponent };